import { moduleProviderFactory } from "core/providers";
import { FacilityOrderNewFlowClinicalPreview } from "application/facility-order-new-flow-clinical/pages";
import { InsuranceCoverageStatusOverviewEmailEdit } from "application/insurance-coverage-status-overview/pages";
import { DocumentationRequestEmailEdit } from "application/documentation-request/pages";
import { FacilityOrderTemplateNewFlowPatientCreate } from "application/facility-order-new-flow/pages";

(function () {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: "master.app.main.facility-order",
				pattern: "/facility-orders",
				children: [
					{
						name: "master.app.main.facility-order.facility-order-new-flow.clinical-preview",
						pattern: "/:id/new-flow/clinical",
						authorization: "facilityOrderSection.update",
						component: FacilityOrderNewFlowClinicalPreview,
						data: {
							// title: "FACILITY_ORDER.CRUMB.CLINICAL_REVIEW",
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.CLINICAL_REVIEW",
									route: 'master.app.main.facility-order.facility-order-new-flow.clinical-preview'
								}
							],
							back: "master.app.main.facility-order.facility-order-new-flow.list",
						},

					},
					{
						name: "master.app.main.facility-order.facility-order-new-flow.overview",
						pattern: "/:facilityOrderId/new-flow/email",
						component: InsuranceCoverageStatusOverviewEmailEdit,
						data: {
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.CLINICAL_REVIEW",
									route: 'master.app.main.facility-order.facility-order-new-flow.clinical-preview'
								},
								{
									title: "INSURANCE_COVERAGE_STATUS_OVERVIEW.TITLE",
									route: 'master.app.main.facility-order.facility-order-new-flow.overview'
								}
							]
						}
					},
					{
						name: "master.app.main.facility-order.documentation-request-new-flow.edit-email",
						pattern: "/:facilityOrderId/new-flow/edit-email",
						component: DocumentationRequestEmailEdit,
						data: {
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.CLINICAL_REVIEW",
									route: 'master.app.main.facility-order.facility-order-new-flow.clinical-preview'
								},
								{
									title: "DOCUMENTATION_REQUEST.TITLE",
									route: 'master.app.main.facility-order.documentation-request-new-flow.edit-email'
								}
							]
						}
					},
					{
						name: "master.app.main.facility-order.facility-order-new-flow.clinical-preview-create-patient",
						pattern: "/:id/new-flow/clinical-review/create-patient",
						authorization: "facilityOrderSection.create",
						tabTitle: 'Create New Patient',
						component: FacilityOrderTemplateNewFlowPatientCreate,
						data: {
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.CLINICAL_REVIEW",
									route: 'master.app.main.facility-order.facility-order-new-flow.clinical-preview'
								},
								{
									title: "FACILITY_ORDER.CRUMB.CREATE_NEW_PATIENT",
									route: 'master.app.main.facility-order.facility-order-new-flow.clinical-preview-create-patient'
								}
							],
							back: "master.app.main.facility-order.facility-order-new-flow.clinical-preview",
						},
					}			
				]
			}
		],
		menu: [
			{
				title: "MENU.FACILITY_ORDERS",
				icon: "package",
				authorization: "coreUserSection.read",
				order: 5,
				subMenu: [
					{
						title: "MENU.FACILITY_ORDERS_SUB",
						authorization: "facilityOrderSection.read",
						route: "master.app.main.facility-order.facility-order-new-flow.list",
						order: 2,
					}
				]
			},
		]
	});
})();
